import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "revenda-clientes-page"
  }, [_c('section', {
    staticClass: "reseller-summary"
  }, [_c('div', [_c('span', {
    staticClass: "summary-kicker"
  }, [_vm._v("Revenda")]), _c('h2', [_vm._v(_vm._s(_vm.revenda.nome || "Revenda não informada"))]), _c('div', {
    staticClass: "summary-details"
  }, [_c('span', [_vm._v("Endereço: " + _vm._s(_vm.enderecoRevenda))]), _c('span', [_vm._v("Telefone: " + _vm._s(_vm.revenda.fone || "Não informado"))])])]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: _vm.$route.params.rota
      }
    }
  }, [_vm._v(" Voltar ")])], 1), _c('section', {
    staticClass: "metric-grid"
  }, [_c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Total de clientes")]), _c('strong', [_vm._v(_vm._s(_vm.metricas.total))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Ativos")]), _c('strong', [_vm._v(_vm._s(_vm.metricas.ativos))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Bloqueados")]), _c('strong', [_vm._v(_vm._s(_vm.metricas.bloqueados))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Com apps")]), _c('strong', [_vm._v(_vm._s(_vm.metricas.comApps))])])]), _c('section', {
    staticClass: "list-controls"
  }, [_c('b-form-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "Buscar cliente, CNPJ, cidade ou plugin..."
    },
    model: {
      value: _vm.busca,
      callback: function callback($$v) {
        _vm.busca = $$v;
      },
      expression: "busca"
    }
  }), _c('div', {
    staticClass: "filter-chips"
  }, _vm._l(_vm.filtrosRapidos, function (filtro) {
    return _c('button', {
      key: filtro.value,
      staticClass: "filter-chip",
      class: {
        ativo: _vm.filtroRapido === filtro.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.filtroRapido = filtro.value;
        }
      }
    }, [_vm._v(" " + _vm._s(filtro.text) + " ")]);
  }), 0)], 1), _c('section', {
    staticClass: "table-shell"
  }, [!_vm.clientes.length ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v(" Nenhum cliente vinculado a esta revenda. ")]) : !_vm.clientesFiltrados.length ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v(" Nenhum cliente encontrado para sua busca. ")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover reseller-client-table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.clientesFiltrados, function (cliente) {
    return _c('tr', {
      key: _vm.clienteKey(cliente)
    }, [_c('td', [_c('div', {
      staticClass: "client-name"
    }, [_vm._v(_vm._s(cliente.cliente || "Sem nome"))]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(" " + _vm._s(_vm.cidadeUfCliente(cliente)) + " ")]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(" Data criação: " + _vm._s(_vm.formatarDataLista(cliente.data_criacao || cliente.data_cadastro)) + " ")])]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.documentoCliente(cliente)))])]), _c('td', [_c('div', [_vm._v(_vm._s(cliente.fone || "Não informado"))]), cliente.email ? _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(_vm._s(cliente.email))]) : _vm._e()]), _c('td', [_c('div', {
      staticClass: "plan-name"
    }, [_vm._v(_vm._s(_vm.nomePlanoLicenca(cliente)))]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(" Vence: " + _vm._s(_vm.formatarDataLista(_vm.dataValidadeLicenca(cliente))) + " ")]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(" Pagamento: " + _vm._s(_vm.formatarDataLista(cliente.data_pagamento)) + " ")])]), _c('td', [_vm.totalAppsAtivosLicenca(cliente) > 0 ? _c('div', [_c('div', {
      staticClass: "apps-count"
    }, [_vm._v(" " + _vm._s(_vm.totalAppsAtivosLicenca(cliente)) + " apps ativos ")]), _c('div', {
      staticClass: "apps-names"
    }, [_vm._v(" " + _vm._s(_vm.nomesAppsResumo(cliente)) + " ")]), _vm.appsAtivosLicenca(cliente).length ? _c('button', {
      staticClass: "btn btn-xs btn-light-primary mt-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirModalApps(cliente);
        }
      }
    }, [_vm._v(" Ver apps ")]) : _vm._e()]) : _c('span', {
      staticClass: "table-muted font-weight-bold"
    }, [_vm._v(" Sem apps ativos ")])]), _c('td', [_c('div', {
      staticClass: "license-line"
    }, [_c('span', [_vm._v("Anual")]), _c('strong', [_vm._v(" " + _vm._s(_vm.formatarMoedaLicenca(_vm.totalAnualLicenca(cliente))) + " ")])]), _c('div', {
      staticClass: "license-line"
    }, [_c('span', [_vm._v("Mensal")]), _c('strong', [_vm._v(" " + _vm._s(_vm.formatarMoedaLicenca(_vm.totalMensalRecorrenteLicenca(cliente))) + "/mês ")])])]), _c('td', [_c('div', {
      staticClass: "status-stack"
    }, [_c('span', {
      staticClass: "label label-inline",
      class: _vm.clienteAtivo(cliente) ? 'label-light-success' : 'label-light-danger'
    }, [_vm._v(" " + _vm._s(_vm.clienteAtivo(cliente) ? "Ativo" : "Inativo") + " ")]), _c('span', {
      staticClass: "label label-inline",
      class: _vm.clienteBloqueado(cliente) ? 'label-light-danger' : 'label-light-success'
    }, [_vm._v(" " + _vm._s(_vm.clienteBloqueado(cliente) ? "Bloqueado" : "Não bloqueado") + " ")])])])]);
  }), 0)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-apps-cliente-revenda",
      "title": _vm.clienteAppsSelecionado ? 'Apps do cliente - ' + _vm.clienteAppsSelecionado.cliente : 'Apps do cliente',
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    }
  }, [!_vm.appsClienteSelecionado.length ? _c('div', {
    staticClass: "empty-state compact"
  }, [_vm._v(" Nenhum app ativo para este cliente. ")]) : _c('div', {
    staticClass: "apps-modal-list"
  }, _vm._l(_vm.appsClienteSelecionado, function (app, index) {
    return _c('div', {
      key: 'app_' + index,
      staticClass: "app-detail-item"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.nomeAppLicenca(app)))]), _c('span', {
      staticClass: "app-type"
    }, [_vm._v(_vm._s(_vm.tipoAppLicenca(app)))]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v("Origem: " + _vm._s(_vm.origemAppLicenca(app)))])]), _c('div', {
      staticClass: "app-price"
    }, [_vm._v(" " + _vm._s(_vm.textoValorAppLicenca(app)) + " ")])]);
  }), 0)]), _c('b-modal', {
    attrs: {
      "id": "modal-gestao-apps-cliente-revenda",
      "title": _vm.clienteAppsGestao ? 'Apps do cliente - ' + (_vm.clienteAppsGestao.cliente || _vm.clienteAppsGestao.nome) : 'Apps do cliente',
      "hide-footer": "",
      "centered": "",
      "size": "xl"
    }
  }, [_c('div', {
    staticClass: "apps-gestao-modal"
  }, [_c('div', {
    staticClass: "apps-gestao-header"
  }, [_c('div', [_c('span', {
    staticClass: "table-muted d-block"
  }, [_vm._v("Saldo disponível da revenda")]), _c('strong', {
    staticClass: "apps-gestao-saldo"
  }, [_vm._v(_vm._s(_vm.formatarMoedaLicenca(_vm.saldoAppsRevenda.disponivel)))]), _c('span', {
    staticClass: "table-muted d-block mt-1"
  }, [_vm._v(" Licenças disponíveis: " + _vm._s(_vm.licencasMultiempresaDisponiveis) + " ")])]), _c('div', [_c('span', {
    staticClass: "table-muted d-block"
  }, [_vm._v("Cliente selecionado")]), _c('strong', [_vm._v(_vm._s(_vm.clienteAppsGestao ? _vm.clienteAppsGestao.cliente || _vm.clienteAppsGestao.nome : "Não informado"))])])]), _vm.loadingAppsClienteGestao ? _c('div', {
    staticClass: "empty-state compact"
  }, [_vm._v(" Carregando apps disponíveis... ")]) : !_vm.featuresGestaoCliente.length ? _c('div', {
    staticClass: "empty-state compact"
  }, [_vm._v(" Nenhum módulo/plugin disponível para este cliente. ")]) : _c('div', {
    staticClass: "apps-gestao-list"
  }, _vm._l(_vm.featuresGestaoCliente, function (feature) {
    return _c('div', {
      key: feature.code,
      staticClass: "apps-gestao-item"
    }, [_c('div', {
      staticClass: "apps-gestao-main"
    }, [_c('b-form-checkbox', {
      staticClass: "mr-3 mt-1",
      attrs: {
        "switch": ""
      },
      model: {
        value: feature.active,
        callback: function callback($$v) {
          _vm.$set(feature, "active", $$v);
        },
        expression: "feature.active"
      }
    }), _c('div', [_c('strong', [_vm._v(_vm._s(feature.name))]), _c('span', {
      staticClass: "app-type ml-2"
    }, [_vm._v(" " + _vm._s(feature.type === "plugin" ? "Plugin" : "Módulo") + " ")]), _c('div', {
      staticClass: "table-muted"
    }, [_vm._v(_vm._s(_vm.formatarMoedaLicenca(feature.monthly_price)) + "/mês")])])], 1), _c('div', {
      staticClass: "apps-gestao-controls"
    }, [_c('div', [_c('label', {
      staticClass: "apps-gestao-label"
    }, [_vm._v("Período (meses)")]), _c('b-form-select', {
      attrs: {
        "disabled": !feature.active,
        "options": _vm.opcoesPeriodoMeses
      },
      model: {
        value: feature.months,
        callback: function callback($$v) {
          _vm.$set(feature, "months", _vm._n($$v));
        },
        expression: "feature.months"
      }
    })], 1), feature.billing_mode === 'per_quantity' ? _c('div', [_c('label', {
      staticClass: "apps-gestao-label"
    }, [_vm._v("Quantidade")]), _c('b-form-input', {
      attrs: {
        "type": "number",
        "min": feature.min_quantity,
        "max": feature.max_quantity,
        "disabled": !feature.active
      },
      model: {
        value: feature.quantity,
        callback: function callback($$v) {
          _vm.$set(feature, "quantity", _vm._n($$v));
        },
        expression: "feature.quantity"
      }
    })], 1) : _vm._e(), _c('div', {
      staticClass: "apps-gestao-total"
    }, [_c('span', [_vm._v("Total a consumir")]), _c('strong', [_vm._v(_vm._s(_vm.formatarMoedaLicenca(_vm.totalFeatureGestao(feature))))])])])]);
  }), 0), _c('div', {
    staticClass: "apps-gestao-footer"
  }, [_c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" Total a consumir: " + _vm._s(_vm.formatarMoedaLicenca(_vm.totalConsumoAppsGestao)) + " ")]), _c('div', {
    staticClass: "table-muted"
  }, [_vm._v(" Saldo restante: " + _vm._s(_vm.formatarMoedaLicenca(_vm.saldoRestanteAppsGestao)) + " ")]), _c('div', {
    staticClass: "table-muted"
  }, [_vm._v(" Multiempresa: " + _vm._s(_vm.consumoLicencasMultiempresa) + " licença(s), " + _vm._s(_vm.devolucaoLicencasMultiempresa) + " devolvida(s), " + _vm._s(_vm.saldoLicencasMultiempresa) + " restante(s) ")])]), _c('div', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.salvandoAppsClienteGestao
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-gestao-apps-cliente-revenda');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.salvandoAppsClienteGestao || !_vm.featuresGestaoCliente.length || _vm.consumoLicencasMultiempresa > _vm.licencasMultiempresaDisponiveis
    },
    on: {
      "click": _vm.salvarAppsClienteGestao
    }
  }, [_vm.salvandoAppsClienteGestao ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.salvandoAppsClienteGestao ? "Salvando..." : "Salvar Apps") + " ")], 1)], 1)])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cliente")]), _c('th', [_vm._v("Documento")]), _c('th', [_vm._v("Contato")]), _c('th', [_vm._v("Plano / Validade")]), _c('th', [_vm._v("Apps")]), _c('th', [_vm._v("Licença")]), _c('th', [_vm._v("Status")])])]);
}];
export { render, staticRenderFns };